import React, { ComponentProps } from 'react'
import { DesktopOnly } from '@components/MediaQuery'
import { TabularNav } from './TabularNav'

type Props = ComponentProps<typeof TabularNav>

export const PublicDesktopMenu = (props: Props) => {
  return (
    <DesktopOnly>
      <TabularNav {...props} />
    </DesktopOnly>
  )
}
